import { render, staticRenderFns } from "./Game5-5.vue?vue&type=template&id=7e1e4352&scoped=true&"
import script from "./Game5-5.vue?vue&type=script&lang=js&"
export * from "./Game5-5.vue?vue&type=script&lang=js&"
import style0 from "./Game5-5.vue?vue&type=style&index=0&id=7e1e4352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1e4352",
  null
  
)

export default component.exports